import { useEffect, useState } from 'react';

/** Minimal hash router: `#/products/<id>/packs` → ['products', '<id>', 'packs']. */
export function useRoute(): string[] {
  const read = () => window.location.hash.replace(/^#\/?/, '').split('/').filter(Boolean);
  const [route, setRoute] = useState(read);
  useEffect(() => {
    const onChange = () => {
      setRoute(read());
    };
    window.addEventListener('hashchange', onChange);
    return () => {
      window.removeEventListener('hashchange', onChange);
    };
  }, []);
  return route;
}

export const navigate = (path: string): void => {
  window.location.hash = path.startsWith('/') ? path : `/${path}`;
};
